export const wordPool = {
  title: 'Word Pool',
  subtitle: 'Browse words and phrases by level',
  
  // Filters
  filterByLanguage: 'Filter by Language',
  filterByLevel: 'Filter by Level',
  allLanguages: 'All Languages',
  allLevels: 'All Levels',
  
  // Languages
  japanese: '日本語',
  korean: '한국어',
  english: 'English',
  
  // Levels
  levelA: 'Level A',
  levelB: 'Level B',
  levelC: 'Level C',
  
  // Table Headers
  word: 'Word/Phrase',
  meaning: 'Meaning',
  language: 'Language',
  level: 'Level',
  
  // Actions
  addWord: 'Add Word',
  search: 'Search',
  searchPlaceholder: 'Search words...',
  
  // Messages
  noWords: 'No words found',
  loading: 'Loading...'
};
